import React from 'react';
import './index.scss';
import classNames from 'classnames';

function Block(
  props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement>
): React.ReactElement {
  const {
    className,
    children,
    ...rest
  } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div className={classNames(['block', className])} {...rest}>
      {children}
    </div>
  );
}

Block.Title = function Title({ children }: {
  children: React.ReactNode
}): React.ReactElement {
  return (
    <h4 className="medium title">{children}</h4>
  );
};

export default Block;
